const cleanURL = (url = "") => {
  return url.replace(/http[s]?:\/\//, "");
};

export default cleanURL;
